import { BaseFieldFilter, NativeFieldFilter } from 'api/dashboard/widget';
import { SingleUserField } from 'components/organisms/tasks/fields';
import { Operation } from 'components/organisms/tasks/filters/operations';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { SingleUserFieldFilter } from 'components/organisms/tasks/filters/single-user';
import { unreachable } from 'utils/unreachable';
import { fromApiValue, toType } from './select';

const toApiFormat = (filter: SingleUserFieldFilter): BaseFieldFilter => {
  switch (filter.type) {
    case SelectFilterOperationType.IsEmpty:
      return {
        operation: Operation.IsEmpty,
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsNotEmpty:
      return {
        operation: Operation.IsNotEmpty,
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.Is:
      return {
        operation: Operation.Value,
        value: filter.value == null ? '' : String(filter.value),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsNot:
      return {
        operation: Operation.IsNot,
        value: filter.value == null ? '' : String(filter.value),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsNoneOf:
      return {
        operation: Operation.NoneOf,
        value: filter.value == null ? '' : filter.value.join(','),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsOneOf:
      return {
        operation: Operation.OneOf,
        value: filter.value == null ? '' : filter.value.join(','),
        sourceType: filter.field.sourceType,
      };
    default:
      return unreachable(filter);
  }
};

const parse = (
  { value, operation }: NativeFieldFilter,
  field: SingleUserField,
): SingleUserFieldFilter => {
  const type = toType(operation);

  switch (type) {
    case SelectFilterOperationType.IsEmpty:
    case SelectFilterOperationType.IsNotEmpty:
      return { field, type };
    case SelectFilterOperationType.Is:
    case SelectFilterOperationType.IsNot:
      return { field, type, value: (fromApiValue(value ?? '') ?? [])[0] };
    case SelectFilterOperationType.IsOneOf:
    case SelectFilterOperationType.IsNoneOf:
      return { field, type, value: fromApiValue(value ?? '') ?? [] };
    case SelectFilterOperationType.IsAtLeast:
    case SelectFilterOperationType.IsAtMost:
    default:
      return unreachable(
        `${type} cannot be parsed for ${field.type} field` as never,
      );
  }
};

export const SingleUserFilter = {
  parse,
  toApiFormat,
  from: fromApiValue,
};
